/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ExportInvoiceQuickbooksInput = {
    invoiceId?: string | null | undefined;
    customerId?: string | null | undefined;
    taxCodeId?: string | null | undefined;
    blankReference?: boolean | null | undefined;
    exportNames?: boolean | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type exportInvoiceQuickbooksMutationVariables = {
    input: ExportInvoiceQuickbooksInput;
};
export type exportInvoiceQuickbooksMutationResponse = {
    readonly exportInvoiceQuickbooks: {
        readonly invoice: {
            readonly quickbooksId: number | null;
        } | null;
    } | null;
};
export type exportInvoiceQuickbooksMutation = {
    readonly response: exportInvoiceQuickbooksMutationResponse;
    readonly variables: exportInvoiceQuickbooksMutationVariables;
};



/*
mutation exportInvoiceQuickbooksMutation(
  $input: ExportInvoiceQuickbooksInput!
) {
  exportInvoiceQuickbooks(input: $input) {
    invoice {
      quickbooksId
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "ExportInvoiceQuickbooksInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quickbooksId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "exportInvoiceQuickbooksMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ExportInvoiceQuickbooksPayload",
        "kind": "LinkedField",
        "name": "exportInvoiceQuickbooks",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InvoiceType",
            "kind": "LinkedField",
            "name": "invoice",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "exportInvoiceQuickbooksMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ExportInvoiceQuickbooksPayload",
        "kind": "LinkedField",
        "name": "exportInvoiceQuickbooks",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InvoiceType",
            "kind": "LinkedField",
            "name": "invoice",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "exportInvoiceQuickbooksMutation",
    "operationKind": "mutation",
    "text": "mutation exportInvoiceQuickbooksMutation(\n  $input: ExportInvoiceQuickbooksInput!\n) {\n  exportInvoiceQuickbooks(input: $input) {\n    invoice {\n      quickbooksId\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'b78709a00ab67efb92c01a72f52fb991';
export default node;
